import { render, staticRenderFns } from "./RewardRulePage.vue?vue&type=template&id=d6d8dde2&"
import script from "./RewardRulePage.vue?vue&type=script&lang=jsx&"
export * from "./RewardRulePage.vue?vue&type=script&lang=jsx&"
import style0 from "./RewardRulePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports